import { render } from "./App.vue?vue&type=template&id=ffbf69e0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=ffbf69e0&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__